import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'dialog-courrier',
    templateUrl: 'dialog-courrier.component.html',
    styleUrls: ['dialog-courrier.component.scss']
})
export class CourrierDialog implements OnInit {
    
    dossier: any;
    subscribe: any = [];
    messageError: string = "";
    fragments: any;
    fileTypeName : string = "";
    fileurl: string;
    name: any;
    typeName = "";
    html = "";

    constructor(
        private appService: AppService,
        public dialogRef: MatDialogRef<CourrierDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        console.log("data courrier dialog ===>", this.data)
        this.dossier = this.data.dossier
        this.html = this.data.html;
        this.fileTypeName  = this.data.fileTypeName;
        this.typeName = this.data.type;

        setTimeout(() => {
            const node = document.createElement('script');
            node.src = '/assets/main.js'
            node.type = 'text/javascript';
            node.id = 'cobhamjsexjs';
            document.getElementsByTagName('head')[0].appendChild(node);
        }, 1000)

    }
    printRap(){
        let printWindow = window.open('', 'PRINT');

        printWindow.document.write(document.querySelector('.rapport-display').innerHTML);
    
        printWindow.document.close(); // necessary for IE >= 10
        printWindow.focus(); // necessary for IE >= 10*/
    
        printWindow.print();
        printWindow.close();
    
        return true;
    }

    downloadInModal(exportType) {
        window['tryga']('send', 'event', this.typeName, 'export_' + exportType, this.fileTypeName , '');

        if (this.subscribe && this.subscribe['downloadInModal']) {
            this.subscribe['downloadInModal'].unsubscribe();
        }

        let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"});
        this.name = this.dossier.nom + "_" + this.dossier.prenom + "_" 
            + this.typeName + "_" + dategeneration + '.' + exportType.toLowerCase();
        this.name = this.name.replace(' ', '_')

        this.subscribe['downloadInModal'] = 
            this.downloadFile(this.dossier.id, this.typeName, this.fileTypeName , exportType)
            .subscribe((res)=>{
                if (res) {
                    let aDownload = document.createElement('a')
                    aDownload.download = this.name
                    aDownload.href = URL.createObjectURL(res)
                    document.body.appendChild(aDownload)
                    aDownload.click()
                    document.body.removeChild(aDownload)
                }else{
                    this.messageError = "Une erreur est survenue lors de l'export.";
                    setTimeout(()=>{this.messageError = ""}, 5000);
                }
                
            },err=>{
                this.messageError = "Une erreur est survenue lors de l'export.";
                    setTimeout(()=>{this.messageError = ""}, 5000);
            })
    }

    

    downloadFile(dossierId, fileTypeName, fileName, exportType) {
        if (fileTypeName === "courrier") {
            return this.appService.downloadCourrier(dossierId, fileName, exportType);
        }
        if (fileTypeName === "rapport") {
            return this.appService.downloadrapport(dossierId, fileName, exportType);
        }
    }

    dismissDialog(){
        document.getElementById('cobhamjsexjs').remove();
        this.dialogRef.close();
    }

    analyseRapportClick(e){
        console.log('rapport-click')
        let element = e.target
        // cas de l'ouverture de la popup
        if (element.classList &&
            (element.classList.contains('bible-anchor'))
        ) {
            window['tryga']('send', 'event', 'rapports', 'bible_ouverture', element.getAttribute('data-ids'), ''); // #2235 GA sur les fragments de bible
            return
        }
        let btn = null
        let count = 3
        do {
            if (element.classList &&
                (element.classList.contains('btn-ajout') || element.classList.contains('btn-supp'))
            ) {
                btn = element
            }
            element = element.parentElement
            console.log(count)
        } while (btn == null && count-- > 0);
        if (!btn) {
            return
        }

        let action    = btn.classList.contains('btn-supp') ? 1 : 0
        let newFargs = btn.getAttribute('data-ids')
        if (newFargs.indexOf(',') > -1) {
            newFargs = newFargs.split(',')
        }
        else {
            newFargs = [newFargs]
        }
console.log(action, newFargs, this.fragments)
        newFargs.forEach((newFrag) => {
            if (action == 1) {
                if (this.fragments.indexOf(newFrag) > -1) {
                    delete this.fragments[this.fragments.indexOf(newFrag)];
                    window['tryga']('send', 'event', 'rapports', 'bible_deselection', newFrag, ''); // #2235 GA sur les fragments de bible
                }
            }
            else {
                if (this.fragments.indexOf(newFrag) == -1) {
                    this.fragments.push(newFrag)
                    window['tryga']('send', 'event', 'rapports', 'bible_selection', newFrag, ''); // #2235 GA sur les fragments de bible
                }
            }
        })
        this.fragments = this.fragments.filter(e=>e) // retirer les éléments vide
console.log(this.fragments)
        this.appService.setBibleSnippet(this.dossier.id,this.fileTypeName , this.fragments).subscribe((res)=>{
            console.log(res)
        })
    }
}